<template>
  <div>
  </div>
</template>

<script>
  import { Toast } from 'mint-ui'
  export default {
    name: "check",
    data () {
      return {
      }
    },
    methods: {
      getUser () {
        this.$http.getUser().then((response) => {
          if (response.state === 2) {
            this.$store.commit("setUserInfo", {})
            this.$store.commit("setUserInfo", response.data)
            let type = response.data.type
            if (response.data.phoneCheck === false) {
              this.$router.push({path: '/update-phone',query: {type: type}})
            } else {
              if (type === 1) {
                this.$router.push({path: '/my-information'})
              } else if (type === 2) {
                this.$router.push({path: '/house-property'})
              } else if (type === 3) {
                this.$router.push({path: '/my-Charge'})
              } else if (type === 4) {
                this.$router.push({path: '/heating-charge'})
              }
            }
          } else {
            Toast({
              duration: 2000,
              message: response.msg
            })
            setTimeout(function () {
              localStorage.clear()
              window.WeixinJSBridge.call('closeWindow')
            },2000)
          }
        })
      }
    },
    mounted () {
      this.getUser()
    }
  }
</script>

<style scoped>
  .img-icon {
    width: 70px;
    height: 70px;
  }

  .img {
    text-align: center;
    margin-top: 10vh;
  }

  .success {
    width: 100%;
    height: 20vh;
    border-bottom: 1px solid #F2F6FC;
  }

  .success-detail {
    border-bottom: 1px solid #F2F6FC;
    padding-bottom: 15px;
  }

  .col-left-suc {
    margin-top: 5px;
    font-size: 13px;
    font-weight: 800;
    margin-left: 20px;
    color: #909399;
  }

  .col-right {
    /*background-color: #DCDEE3;*/
    border-radius: 4px;
    padding: 5px;
    font-size: 15px;
    font-weight: 800;
  }

  .water-num {
    border-bottom: 1px solid #F2F6FC;
    padding-bottom: 15px;
  }

  .button {
    margin-top: 15px;
    width: 100%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/check.vue